// extracted by mini-css-extract-plugin
export default {"seatsInfo":"ED6-l","firstTicket":"_3Kf3W","lastTicket":"NMG-l","button":"PEq78"};